<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="trade_modal_trriger">        
        <div class="trade-modal u-window">
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <p class="notice" v-if="trade_type == 'apply'">发送链接向好友索要这张卡牌。</p>
                    <p class="notice" v-if="trade_type == 'send'">发送链接向好友赠送这张卡牌。</p>
                    <div class="notice" v-if="trade_type == 'apply_comfirm'">
                        <p>确定赠送这张卡牌给好友吗？</p>
                        <p>赠送之后你将失去这张卡牌。</p>
                    </div>
                    <div class="notice" v-if="trade_type == 'send_comfirm'">
                        <p>你的好友赠送您一张周年庆卡牌。</p>
                    </div>

                    <div class="card-view"><div class="card c-sample" :style="{'backgroundImage': 'url( '+ require('@/assets/images/card-card-' + cid + '.jpg') +' )'}"></div></div>                   
                </div>
                <div class="card-num" v-if="actComplete"><em>X</em>1</div>
            </div>
            <div class="u-btn apply cobyOrderSn" v-if="trade_type == 'apply'" data-clipboard-action="copy" :data-clipboard-text="text" @click="copy"></div>
            <div class="u-btn send cobyOrderSn" v-if="trade_type == 'send'" data-clipboard-action="copy" :data-clipboard-text="text" @click="copy"></div>
            <div class="u-btn send-check" v-if="trade_type == 'apply_comfirm'" @click="acceptRequest"></div>
            <div class="apply-check" v-if="trade_type == 'send_comfirm'">
                <div class="u-btn ok" @click="acceptShare"></div>
                <div class="u-btn cancel" @click="closeModal"></div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import GLOBAL from '@/assets/js/global.js';

export default {
    name : 'trade-modal',
    data : function (){
        return {
            actComplete : false,
            imgSrc : 'https://web-resource.17m3.com/m3guo/202109/kdcard/images/card/',
        }
    },
    props : {
        trade_modal_trriger : {
            default : false
        },
        trade_type :{
            default : 'apply',
            type : String,
            require : true,
        },
        cid : {
            require : true,
        },
        text : {
            default : '',
            type : String,
        },
        cdk : {
            default : '',
        },
        request : {
            default : '',
        }        
    },
    methods: {
        closeModal(){
            document.body.removeEventListener('touchmove',GLOBAL.bodyScroll,{ passive: false });
            ['trade_type','cardclz','key','request'].map(item => localStorage.setItem(item, ''));
            this.$emit("modal_switch", 'trade_modal_trriger');
            this.actComplete = false;
        },
        apply(){
            //索要
            this.actComplete = true;
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new this.clipboard(".cobyOrderSn");
            clipboard.on('success', function () {
              _this.$toast.info("复制成功")
            });
            clipboard.on('error', function () {
              _this.$toast.info("复制失败")
            });
        },
        acceptShare(){
            //接受卡片
            var _v = this;
            _v.$axios.post(GLOBAL.ajax_url_map.acceptShare + '?ver=' + GLOBAL.version,GLOBAL.param({
                key : _v.cdk
            }))
            .then(function(response){
                if(response.data.code == 0){
                    _v.closeModal();
                    _v.$toast.info('您已成功接收卡片~');
                    _v.$emit("cardinfo_update", {
                        class : response.data.data.class,
                        cnt : 1
                    });                    
                }
                else{
                    _v.$toast.info(response.data.message);
                }                
            });
        },
        acceptRequest(){
            //主动赠送
            var _v = this;
            _v.$axios.post(GLOBAL.ajax_url_map.acceptRequest + '?ver=' + GLOBAL.version,GLOBAL.param({
                key : _v.request
            }))
            .then(function(response){
                if(response.data.code == 0){
                    _v.closeModal();
                    _v.$toast.info('您的好友已经收到卡片~');
                    _v.$emit("cardinfo_update", {
                        class : response.data.data.class,
                        cnt : -1
                    });                    
                }
                else{
                    _v.$toast.info(response.data.message);
                }
            });            
        },      
    },    
}
</script>

<style>
    .trade-modal .dialog-content{
        position: relative;
        width: 5.18rem;
        height: 7.37rem;
        margin: 0 auto .55rem;
        background-image: url(~@/assets/images/modal-card.png);
    }

    .trade-modal .u-btn.close{
        position: absolute;
        top: -.3rem;
        right: -.2rem;
    }    

    .trade-modal .dialog-wrapper{
        padding: .6rem .6rem 0;
    }

    .trade-modal .card-view{
        position: absolute;
        left: 50%;
        bottom: .7rem;
        width: 3.68rem;
        height: 5.18rem;
        background-image: url(~@/assets/images/bg-trade-card.png);
        transform: translateX(-50%);
    }

    .trade-modal .card{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 2.43rem;
        height: 4.08rem;
        background-image: url(~@/assets/images/card-filp.png);
        background-size: 100% auto;
        background-repeat: no-repeat;
        transform: translate(-50%,-52%);
    }

    .trade-modal .notice{
        text-align: center;
        color: #ffc26d;
    }

    .trade-modal .u-btn.apply{
        width: 2.46rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-apply-card.png);    
    }

    .trade-modal .u-btn.send-check{
        width: 2.46rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-check.png);    
    }
    
    .trade-modal .u-btn.send{
        width: 2.46rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-card-send.png);    
    }

    .trade-modal .apply-check{
        display: flex;
        justify-content: center;
    }

    .trade-modal .u-btn.ok{
        width: 2.46rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-yes.png);    
    }
    
    .trade-modal .u-btn.cancel{
        width: 2.46rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-no.png);    
    }     

</style>


// WEBPACK FOOTER //
// src/components/cardTradeModal.vue